import React from 'react';
import {Button, Modal} from '@/ui-kits';

interface DeleteConfirmModalPropType {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
export const DeleteConfirmModal: React.FC<DeleteConfirmModalPropType> = props => {
  const {onClose, onConfirm, open} = props;
  return (
    <Modal open={open} onClose={onClose} className="bg-white rounded-xl md:w-auto md:max-w-sm p-5 relative border ">
      {/* Close icon */}
      <Button
        title=""
        leftIcon="close"
        variant="secondary"
        className="absolute top-3 right-3 text-gray-500 border-none p-0 m-3 hover:bg-white"
        onClick={onClose}
      />

      <h2 className="font-FigtreeBold text-lg text-ui_blue mb-3">If you confirm deletion:</h2>

      <ul className="text-sm text-gray-600 list-disc pl-5 space-y-1 ml-4">
        <li>Your access will be limited immediately.</li>
        <li>However, you will not be able to:</li>
        <ul className="ml-6 list-disc ">
          {/* <span className="absolute -left-[9px] top-1 h-1 w-1 p-[1px] rounded-full border-2 border-[#274760] bg-white"></span> */}
          <li>Edit your profile</li>
          {/* <span className="absolute -left-[9px] top-8 h-1 w-1 p-[1px] rounded-full border-2 border-[#274760] bg-white"></span> */}
          <li>Upload health records</li>
          <li>Book consultations</li>
        </ul>
      </ul>
<div className="flex justify-center">
  <Button
    title="Confirm"
    className="mt-4 px-6 w-[204px]"
    onClick={onConfirm}
  />
</div>

    </Modal>
  );
};
